import { FiveByFiveCardStack } from './five-by-five-card-stack';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { PopsCannabis5By5CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/custom-cards-5x5/pops-cannabis-5-by5-card-background/pops-cannabis-5-by-5-card-background.component';
import type { CardData } from '../../../../print-cards/card-data';
import { PopsCannabis5By5CardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/custom-cards-5x5/pops-cannabis-5-by-5-card-stack-content/pops-cannabis-5-by-5-card-stack-content.component';
import { PopsCannabisCardData } from '../../../../print-cards/pops-cannabis-card-data';

export class PopsCannabis5By5CardStack extends FiveByFiveCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> {
    return PopsCannabis5By5CardBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> {
    return PopsCannabis5By5CardStackContentComponent;
  }

  getLeftCutLineText(cardData: PopsCannabisCardData): string | null {
    return cardData?.getLeftLargeText();
  }
}
